/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetDiagnosticDownloadResponseDto
 */
export interface AssetDiagnosticDownloadResponseDto {
    /**
     * Short-lived presigned GET URL (never log this value).
     * @type {string}
     * @memberof AssetDiagnosticDownloadResponseDto
     */
    url: string;
    /**
     * Presigned URL TTL in seconds.
     * @type {number}
     * @memberof AssetDiagnosticDownloadResponseDto
     */
    expiresInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof AssetDiagnosticDownloadResponseDto
     */
    fileName: string;
}

/**
 * Check if a given object implements the AssetDiagnosticDownloadResponseDto interface.
 */
export function instanceOfAssetDiagnosticDownloadResponseDto(value: object): value is AssetDiagnosticDownloadResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('expiresInSeconds' in value) || value['expiresInSeconds'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function AssetDiagnosticDownloadResponseDtoFromJSON(json: any): AssetDiagnosticDownloadResponseDto {
    return AssetDiagnosticDownloadResponseDtoFromJSONTyped(json, false);
}

export function AssetDiagnosticDownloadResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDiagnosticDownloadResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'expiresInSeconds': json['expiresInSeconds'],
        'fileName': json['fileName'],
    };
}

export function AssetDiagnosticDownloadResponseDtoToJSON(json: any): AssetDiagnosticDownloadResponseDto {
    return AssetDiagnosticDownloadResponseDtoToJSONTyped(json, false);
}

export function AssetDiagnosticDownloadResponseDtoToJSONTyped(value?: AssetDiagnosticDownloadResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'expiresInSeconds': value['expiresInSeconds'],
        'fileName': value['fileName'],
    };
}

